export default __webpack_public_path__ + "static/media/10.38abf692.jpg";